// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"ed2fe4df","189":"b4f67835","683":"03921572","860":"a224995d","950":"7c4a3b72"}[chunkId] + ".chunk.css";
};